import { configureStore } from "@reduxjs/toolkit";
import message from "../utils/message/message.slice";
import progress from "../utils/loader/progress.slice";
import account from "../account-information/account.slice";
import app from "../app.slice";
import onboarding from "../onboarding/onboarding.slice";
import config from "../config/config.slice";

export const store = configureStore({
  reducer: {
    app,
    config,
    message,
    progress,
    account,
    onboarding,
  },
});
